/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoTestRegionDTO } from './geoTestRegionDTO';


export interface GeoTestRegionsDataDTO { 
    selectedRegions: Array<GeoTestRegionDTO>;
    testLength: number;
    viewType: GeoTestRegionsDataDTO.ViewTypeEnum;
    targetROAS?: number;
    minimumDetectableROAS?: number;
    targetCPO?: number;
    minimumDetectableCPO?: number;
    geoScopeIds?: Array<number>;
    splitType?: string;
    geoSplitLevel?: string;
    filterParams?: object;
    marketSelectionExecutionId: string;
}
export namespace GeoTestRegionsDataDTO {
    export type ViewTypeEnum = 'ROAS' | 'CPO';
    export const ViewTypeEnum = {
        Roas: 'ROAS' as ViewTypeEnum,
        Cpo: 'CPO' as ViewTypeEnum
    };
}


